import { AccessesKeyEnum } from "../@enum/subaccount/accesses-key/accesses-key.enum";

export const accessRouteMapping: Partial<Record<AccessesKeyEnum, string>> = {
  "bank_account_information:all": "/settings/bank-account",
  "catalog:all": "/catalog",
  "consignment_delivery:action": "/consignment/deliveries",
  "consignment_delivery:view": "/consignment/deliveries",
  "customer_stock:action": "/consignment/customer-stocks",
  "customer_stock:view": "/consignment/customer-stocks",
  "invoice_data:view": "/consignment/invoices",
  "main_dashboard:all": "/",
  "order:action": "/order",
  "order:view": "/order",
  "pos:all": "/cashier",
  "price_monitoring:all": "/keyword-monitoring",
  "product_collection:action": "/inventory/collections",
  "product_collection:view": "/inventory/collections",
  "produk:action": "/inventory/products",
  "produk:view": "/inventory/products",
  "promotion:all": "/promotion/promotion-list",
  "reports_list:all": "/reports",
  "salesperson:all": "/salesperson",
  "settings_order_approval:all": "/settings/approvals",
  "shop_monitoring:all": "/shop-monitoring",
  "stock:action": "/inventory/stocks",
  "stock:view": "/inventory/stocks",
  "virtual_bundling:action": "/inventory/bundling",
  "virtual_bundling:view": "/inventory/bundling",
  // Since we don't have warehouse feature yet, the route is mapped to "/"
  "warehouse:action": "/",
  "warehouse:view": "/",
  "voucher:view": "/voucher",
  "voucher:action": "/voucher",
};

export default accessRouteMapping;
